import { isProduction } from '../../settings'
import { isMobileDevice, redirectToExternalUrl } from 'mmfintech-commons'

import { PreviewPix } from './PreviewPix'
import { PreviewFrame } from './PreviewFrame'
import { PreviewMessage } from './PreviewMessage'
import { PreviewBankwire } from './PreviewBankwire'
import { PreviewInstructions } from './PreviewInstructions'
import { useEventTracker, useRedirects } from 'mmfintech-checkout-commons'

export const DepositResult = ({ session, sessionId, response }) => {
  const { result, resultType, status, action, processingAmount, processingCurrency } = response || {}

  const { redirectToFailurePage, redirectToSuccessPage } = useRedirects(sessionId)

  const { trackEvent } = useEventTracker()

  if (status === 'FAILED') {
    redirectToFailurePage()
    return null
  }

  if (status === 'PROCESSED') {
    redirectToSuccessPage()
    return null
  }

  const redirectToProvider = () => {
    trackEvent(sessionId, 'redirected_to_provider')
    redirectToExternalUrl(result)
  }

  if (action) {
    switch (action) {
      case 'REDIRECT_URL':
        redirectToProvider()
        return

      // case 'REDIRECT_3DS': -- nothing for now

      default:
      //nothing
    }
  }

  switch (resultType) {
    // case 'INTERNAL_EXECUTION':
    // case 'CRYPTO_ADDRESS_DETAILS':
    // case 'CHECKOUT_CRYPTO_ADDRESS_DETAILS':

    case 'INSTRUCTIONS':
      return <PreviewInstructions sessionId={sessionId} result={{ ...result, processingAmount, processingCurrency }} />

    case 'BANKWIRE_DETAILS':
      return <PreviewBankwire result={result} session={session} sessionId={sessionId} />

    case 'MESSAGE':
      return <PreviewMessage result={result} />

    case 'REDIRECT_URL':
      redirectToProvider()
      break

    case 'QR_CODE':
      return <PreviewPix value={result} />

    case 'IFRAME_URL':
      if (isMobileDevice()) {
        redirectToProvider()
      } else {
        trackEvent(sessionId, 'open_provider_in_frame')
        return <PreviewFrame url={result} />
      }
      break

    default:
      if (!isProduction && resultType) {
        console.log(`DepositResult: Unsupported result type ${resultType}`)
      }
  }

  return null
}
